module.exports = __webpack_public_path__ + "media/customize/banner-bottom-right-2c39aedc.svg";